import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { DriversIntegrationTypes, FilesUploadBody } from '../projects/document-scan/drivers-integrations/drivers-integrations.types';
import { DocumentsUploadNotificationsService } from './notification-center/documents-upload-notifications.service';
import { MediaUploadNotificationsService } from './notification-center/media-upload-notifications.service';

@Injectable({
  providedIn: 'root'
})
export class UploadManagerService {
  private processStartedSubject = new Subject<void>();
  public processStarted$ = this.processStartedSubject.asObservable();

  private projectCreatedSubject = new Subject<void>();
  public projectCreated$ = this.projectCreatedSubject.asObservable();

  private uploadErrorSubject = new Subject<void>();
  public uploadError$ = this.uploadErrorSubject.asObservable();

  constructor(
    private readonly documentsUploadNotificationsService: DocumentsUploadNotificationsService,
    private readonly mediaUploadNotificationsService: MediaUploadNotificationsService
  ) { }


  startFilesScanProject(
    files: File[] | FilesUploadBody,
    keywordIds: string[],
    projectName: string,
    vendor: DriversIntegrationTypes
  ): void {
    this.documentsUploadNotificationsService.startFilesScanProject(files, keywordIds, projectName, vendor, {
      onProcessStarted: () => this.processStartedSubject.next(),
      onProjectCreated: () => this.projectCreatedSubject.next(),
      onUploadError: () => this.uploadErrorSubject.next()
    });
  }

  startMediaScanProject(
    files: File[],
    projectId: string,
    fileMetadata: { fileId: string; path: string; name: string }[]
  ): void {
    this.mediaUploadNotificationsService.startMediaScanProject(files, projectId, fileMetadata);
  }
}
